/* eslint no-use-before-define: 0 */

import 'react-datepicker/dist/react-datepicker.css'

import React from 'react';
import { validated } from 'react-custom-validation';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import classNames from 'classnames';

import { isRequired } from 'utils/validations';

import AssignmentDetailsGrid from './AssignmentDetailsGrid';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Icon from 'components/Icon';
import Input from 'components/Input';
import ModalButton from 'components/ModalButton';
import TextArea from 'components/TextArea';

import { ASSIGNMENT_STATES } from './../constants';
import { MODALS } from 'utils/constants';

class AssignmentEditForm extends React.Component {
    static propTypes = {
        assignment: React.PropTypes.object.isRequired,
        closeModal: React.PropTypes.func.isRequired,
        existingAssignmentState: React.PropTypes.string.isRequired,
        handleChange: React.PropTypes.func.isRequired,
        handleDateChange: React.PropTypes.func.isRequired,
        handleStateChange: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        onValid: React.PropTypes.func.isRequired,
        onInvalid: React.PropTypes.func.isRequired,
        openModal: React.PropTypes.func.isRequired
    };

    _generateAdvancedSettingsList() {
        let settings = [];
        let assignment = this.props.assignment;

        if(assignment.performanceSupport === true) {
            settings.push('On Demand');
        }
        if(assignment.mandatory === true) {
            settings.push('Mandatory');
        }
        if(assignment.requireLocation === true) {
            settings.push('Captures Location');
        }
        if(assignment.requireSignature === true) {
            settings.push('Signature Required');
        }
        if(assignment.recurrance !== 'none') {
            settings.push('Recurring');
        }

        if(settings.length > 0) {
            return settings.join(', ');
        } else {
            return null;
        }
    }

    render() {
        let { assignment, closeModal, existingAssignmentState, handleChange, handleDateChange, isSaving, onValid, onInvalid, openModal, $field, $validation } = this.props;


        return (
            <Form className="assignment-edit__form modal-form">
                <FormRow>
                    <Input type="text"
                           name="name"
                           placeholder="Name"
                           value={assignment.name}
                           {...$field('name', (event) => handleChange(event))}
                           onChange={handleChange.bind(this)} />
                    {$validation.name.show && <FormValidationMessage>{$validation.name.error.reason}</FormValidationMessage>}
                </FormRow>

                <FormRow className="assignment-edit__details-grid--wrapper">
                    <AssignmentDetailsGrid assignment={assignment}
                                           handleContentClick={openModal.bind(this, MODALS.ASSIGNMENT_CONTENT_REVIEW)}
                                           handlePinpointsClick={openModal.bind(this, MODALS.ASSIGNMENT_PINPOINTS_REVIEW)}
                                           handleUsersClick={openModal.bind(this, MODALS.ASSIGNMENT_USERS_REVIEW)}
                                           inEditModal={true} />
                    {$validation.contents.show && <FormValidationMessage>{$validation.contents.error.reason}</FormValidationMessage>}
                </FormRow>

                <div className="assignment-edit__dates">
                    <FormRow>
                        <label htmlFor="dateStartDate" className="assignment-edit__date-label">
                            <Icon icon="calendar" /> Start Date
                        </label>
                        <div className={classNames('assignment-edit__datepicker--wrapper', {'date-not-set': assignment.startDate === 0 || assignment.startDate == null, 'disabled': this.props.existingAssignmentState !== ASSIGNMENT_STATES.UNPUBLISHED && this.props.existingAssignmentState !== ASSIGNMENT_STATES.NONE})}>
                            {assignment.startDate === 0 || assignment.startDate == null ? (
                                <label htmlFor="dateStartDate" className="assignment-edit__dates--not-now">
                                    Not Set <Icon icon="carrot-right" />
                                </label>
                            ) : null}
                            <DatePicker id="dateStartDate"
                                        dateFormat="M/D/YY"
                                        disabled={this.props.existingAssignmentState !== ASSIGNMENT_STATES.UNPUBLISHED && this.props.existingAssignmentState !== ASSIGNMENT_STATES.NONE}
                                        name="startDate"
                                        selected={assignment.startDate == null ? null : moment(assignment.startDate)}
                                        {...$field('startDate', (event) => handleDateChange(event, 'startDate'))}
                                        placeholder="Start Date" />
                            {$validation.startDate.show && <FormValidationMessage>{$validation.startDate.error.reason}</FormValidationMessage>}
                        </div>
                    </FormRow>
                    <FormRow>
                        <label htmlFor="dateDueDate" className="assignment-edit__date-label">
                            <Icon icon="calendar" /> Due Date
                        </label>
                        <div className={classNames('assignment-edit__datepicker--wrapper', {'date-not-set': assignment.dueDate === 0 || assignment.dueDate == null})}>
                            {assignment.dueDate === 0 || assignment.dueDate == null ? (
                                <label htmlFor="dateDueDate" className="assignment-edit__dates--not-now">
                                    Not Set <Icon icon="carrot-right" />
                                </label>
                            ) : null}
                            <DatePicker id="dateDueDate"
                                        dateFormat="M/D/YY"
                                        name="dueDate"
                                        selected={assignment.dueDate == null ? null : moment(assignment.dueDate)}
                                        {...$field('dueDate', (event) => handleDateChange(event, 'dueDate'))}
                                        placeholder="Due Date" />
                            {$validation.dueDate.show && <FormValidationMessage>{$validation.dueDate.error.reason}</FormValidationMessage>}
                        </div>
                    </FormRow>
                </div>

                <FormRow>
                    <TextArea name="instructions"
                              placeholder="Instructions"
                              className="assignment-edit__instructions"
                              onChange={handleChange.bind(this)}
                              value={assignment.instructions} />
                </FormRow>

                <FormRow className="assignment-edit__advanced-link--wrapper">
                    <div role="button"
                         className="assignment-edit__advanced-link"
                         onClick={openModal.bind(this, MODALS.ASSIGNMENT_EDIT_ADVANCED)}>
                        <div className="assignment-edit__advanced-link--left">
                            <Icon icon="settings" /> Advanced Settings
                        </div>
                        <div className="assignment-edit__advanced-link--right">
                            {this._generateAdvancedSettingsList()}
                            <Icon icon="carrot-right" />
                        </div>
                    </div>
                </FormRow>

                <div className="modal__buttons">
                    {existingAssignmentState === ASSIGNMENT_STATES.NONE || existingAssignmentState === ASSIGNMENT_STATES.UNPUBLISHED ? (
                        <ModalButton disabled={isSaving === true}
                                     icon="save"
                                     onClick={(event) => {
                                         event.preventDefault();
                                         this.props.handleStateChange(ASSIGNMENT_STATES.UNPUBLISHED);
                                         setTimeout(() => this.props.$submit(onValid, onInvalid), 200);
                                     }}
                                     text="Save Draft" />
                    ) : (
                        <ModalButton disabled={isSaving === true}
                                     icon="check"
                                     onClick={(event) => {
                                         event.preventDefault();
                                         this.props.$submit(onValid, onInvalid);
                                     }}
                                     text="Done" />
                    )}
                    {existingAssignmentState === ASSIGNMENT_STATES.NONE || existingAssignmentState === ASSIGNMENT_STATES.UNPUBLISHED ? (
                        <ModalButton disabled={isSaving === true}
                                     icon="assignments"
                                     onClick={(event) => {
                                         event.preventDefault();
                                         this.props.handleStateChange(ASSIGNMENT_STATES.PUBLISHED);
                                         setTimeout(() => this.props.$submit(onValid, onInvalid), 200);

                                     }}
                                     text="Assign" />
                    ) : null}

                    <ModalButton className="modal-button--cancel"
                                 disabled={isSaving === true}
                                 icon="cancel"
                                 onClick={closeModal.bind(this)}
                                 text="Cancel" />
                </div>
            </Form>
        )
    }
}

function assignmentEditFormValidationConfig(props) {
    const { name, dueDate, startDate, beacons, contents, users, performanceSupport, state } = props.assignment;
    return {
        fields: ['name', 'dueDate', 'startDate', 'contents'],
        validations: {
            name: [
                [isRequired, name]
            ],
            startDate: [
                [hasDateIfRequired, startDate, state]
            ],
            dueDate: [
                [dateLater, dueDate, startDate, 'Due date must be after start date.', state]
            ],
            contents: [
                [hasContentAndUserItems, contents, users, state],
                [hasPinPointIfOnDemand, beacons, performanceSupport]
            ]
        }
    }
}

export default AssignmentEditForm = validated(assignmentEditFormValidationConfig)(AssignmentEditForm);

const hasDateIfRequired = (date, state) => {
    if((state !== ASSIGNMENT_STATES.NONE && state !== ASSIGNMENT_STATES.UNPUBLISHED) && (date == null || date === 0)) {
        return 'Please select a date.';
    } else {
        return null;
    }
};

const dateLater = (dueDate, startDate, message) => {
    if(dueDate == null) {
        return null;
    }

    if(dueDate < startDate) {
        return message;
    } else {
        return null;
    }
}

const hasContentAndUserItems = (contents, users, state) => {
    if((state !== ASSIGNMENT_STATES.NONE && state !== ASSIGNMENT_STATES.UNPUBLISHED) && (contents == null || contents.length === 0 || users == null || users.length === 0)) {
        return 'You must select content and users to assign.';
    } else {
        return null;
    }
};

const hasPinPointIfOnDemand = (beacons, performanceSupport) => {
    if(performanceSupport === true && (beacons == null || beacons.length === 0)) {
        return 'On Demand assignments require a PinPoint.';
    } else {
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentEditForm.js